import React, { useState } from "react";
import { useTranslation } from "@helpers/translate";
import "./index.sass";

const PaymentExecutionStep = ({
  amount = 0,
  network = "TRC-20",
  transactionId = "",
  dateTime = "",
  processingTime = "Instantly",
  onGoToWallet,
  onGoToTrading,
}) => {
  const { __ } = useTranslation();
  const [copiedField, setCopiedField] = useState(null);

  const copyToClipboard = async (value, field) => {
    if (!value) return;

    setCopiedField(field);

    setTimeout(() => {
      setCopiedField((current) => (current === field ? null : current));
    }, 2000);

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(value);
        return;
      }

      const textarea = document.createElement("textarea");
      textarea.value = value;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "fixed";
      textarea.style.top = "-9999px";
      textarea.style.left = "-9999px";

      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    } catch (error) {
      console.error("Copy failed:", error);
    }
  };

  const MONTH_KEYS = [
    "markets.months.jan",
    "markets.months.feb",
    "markets.months.mar",
    "markets.months.apr",
    "markets.months.may",
    "markets.months.jun",
    "markets.months.jul",
    "markets.months.aug",
    "markets.months.sep",
    "markets.months.oct",
    "markets.months.nov",
    "markets.months.dec",
  ];

  const formatTransactionDate = (value) => {
    if (!value) return "—";

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return value;
    }

    const month = __(MONTH_KEYS[date.getMonth()]);
    const day = date.getDate();
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${month} ${day}, ${year} ${hours}:${minutes}:00`;
  };

  return (
    <div className="payment-execution-step">
      <div className="payment-execution-step__success">
        <div className="payment-execution-step__icon">
          <svg
            width="94"
            height="94"
            viewBox="0 0 94 94"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="94" height="94" rx="47" fill="#1C281E" />
            <path
              d="M46.9999 68.9328C44.8399 68.9328 42.6798 68.1116 41.0373 66.4669L40.0452 65.4746C39.7302 65.1596 39.2959 64.9796 38.8527 64.9796H37.4555C32.807 64.9796 29.0224 61.1974 29.0224 56.5466V55.1494C29.0224 54.7061 28.8425 54.2696 28.5275 53.9569L27.5351 52.9646C24.2456 49.6773 24.2456 44.3269 27.5351 41.0374L28.5275 40.0451C28.8425 39.7301 29.0224 39.2958 29.0224 38.8503V37.4531C29.0224 32.8023 32.807 29.0201 37.4555 29.0201H38.8527C39.2959 29.0201 39.7325 28.8401 40.0452 28.5251L41.0373 27.5328C44.3246 24.2456 49.6774 24.2456 52.9646 27.5328L53.957 28.5251C54.272 28.8401 54.706 29.0201 55.1493 29.0201H56.5467C61.1952 29.0201 64.9795 32.8023 64.9795 37.4531V38.8503C64.9795 39.2958 65.1598 39.7301 65.4748 40.0451L66.4668 41.0374C69.7563 44.3246 69.7563 49.6751 66.4668 52.9646L65.4748 53.9569C65.1598 54.2719 64.9795 54.7061 64.9795 55.1494V56.5466C64.9795 61.1974 61.1952 64.9796 56.5467 64.9796H55.1493C54.706 64.9796 54.2697 65.1596 53.957 65.4723L52.9646 66.4669C51.3199 68.1116 49.1599 68.9328 46.9999 68.9328ZM37.453 32.3951C34.6653 32.3951 32.3952 34.6653 32.3952 37.4531V38.8503C32.3952 40.2026 31.8686 41.4738 30.9123 42.4301L29.9202 43.4223C28.964 44.3786 28.4396 45.6476 28.4396 46.9998C28.4396 48.3521 28.964 49.6211 29.9202 50.5773L30.9123 51.5696C31.8686 52.5259 32.3952 53.7971 32.3952 55.1494V56.5466C32.3952 59.3366 34.6653 61.6046 37.453 61.6046H38.8505C40.1847 61.6046 41.4896 62.1446 42.4301 63.0873L43.4224 64.0796C45.3349 65.9898 48.6648 65.9898 50.5773 64.0796L51.5696 63.0873C52.5101 62.1446 53.815 61.6046 55.1493 61.6046H56.5467C59.3345 61.6046 61.6045 59.3344 61.6045 56.5466V55.1494C61.6045 53.7971 62.1312 52.5259 63.0874 51.5696L64.0795 50.5773C65.0357 49.6211 65.5602 48.3521 65.5602 46.9998C65.5602 45.6476 65.0357 44.3786 64.0795 43.4223L63.0874 42.4301C62.1312 41.4738 61.6045 40.2026 61.6045 38.8503V37.4531C61.6045 34.6631 59.3345 32.3951 56.5467 32.3951H55.1493C53.8173 32.3951 52.5124 31.8551 51.5696 30.9124L50.5773 29.9201C48.6648 28.0098 45.3349 28.0098 43.4224 29.9201L42.4301 30.9124C41.4874 31.8551 40.1825 32.3951 38.8505 32.3951H37.453ZM45.9424 52.6923L54.9424 43.6923C55.6017 43.0331 55.6017 41.9643 54.9424 41.3051C54.2832 40.6458 53.2144 40.6458 52.5551 41.3051L44.7477 49.1126L41.4402 45.8051C40.781 45.1458 39.7122 45.1458 39.0529 45.8051C38.3937 46.4643 38.3937 47.5331 39.0529 48.1923L43.5529 52.6923C43.8814 53.0208 44.3135 53.1873 44.7455 53.1873C45.1775 53.1873 45.6139 53.0231 45.9424 52.6923Z"
              fill="#2FA766"
            />
          </svg>
        </div>

        <h1>{__("wallet.deposit.payment_received")}</h1>

        <p>{__("wallet.deposit.payment_successfully_processed")}</p>
      </div>

      <div className="payment-execution-step__overview">
        <div className="payment-execution-step__overview-item payment-execution-step__overview-item--border">
          <p>
            {amount} USD
          </p>
          <span>{__("wallet.deposit.deposit_amount")}</span>
        </div>

        <div className="payment-execution-step__overview-item">
          <p>{processingTime}</p>
          <span>{__("wallet.deposit.processing_time")}</span>
        </div>
      </div>

      <div className="payment-execution-step__details">
        <h2>{__("wallet.deposit.transaction_details")}</h2>

        <div className="payment-execution-step__details-card">
          <div className="payment-execution-step__row">
            <span className="payment-execution-step__label">
              {__("wallet.deposit.transaction_id")}
            </span>

            <div className="payment-execution-step__value payment-execution-step__value--copy">
              <strong>{transactionId || "—"}</strong>

              <div className="payment-execution-step__copy-wrap">
                <button
                  type="button"
                  className="payment-execution-step__copy-button"
                  onClick={() =>
                    copyToClipboard(transactionId, "transactionId")
                  }
                  disabled={!transactionId}
                >
                  {copiedField === "transactionId" ? (
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path
                        d="M13.3334 4L6.00008 11.3333L2.66675 8"
                        stroke="#A6A6A6"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ) : (
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.25 4.16667H6.41667C4.96533 4.16667 4.16667 4.96533 4.16667 6.41667V12.25C4.16667 13.7013 4.96533 14.5 6.41667 14.5H12.25C13.7013 14.5 14.5 13.7013 14.5 12.25V6.41667C14.5 4.96533 13.7013 4.16667 12.25 4.16667ZM13.5 12.25C13.5 13.138 13.138 13.5 12.25 13.5H6.41667C5.52867 13.5 5.16667 13.138 5.16667 12.25V6.41667C5.16667 5.52867 5.52867 5.16667 6.41667 5.16667H12.25C13.138 5.16667 13.5 5.52867 13.5 6.41667V12.25ZM2.5 3.74666V9.58667C2.5 10.3853 2.82206 10.582 2.92806 10.6473C3.16406 10.7913 3.23726 11.0993 3.09326 11.3347C2.9986 11.4887 2.83468 11.5733 2.66602 11.5733C2.57735 11.5733 2.48661 11.5493 2.40527 11.5C1.80461 11.132 1.5 10.4887 1.5 9.58667V3.74666C1.5 2.31866 2.31941 1.5 3.74674 1.5H9.58659C10.7099 1.5 11.2467 1.99265 11.5 2.40531C11.644 2.64065 11.57 2.94865 11.3346 3.09265C11.0986 3.23732 10.792 3.16266 10.6473 2.92733C10.5826 2.82133 10.3853 2.49935 9.58659 2.49935H3.74674C2.86141 2.50002 2.5 2.86133 2.5 3.74666Z"
                        fill="white"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>
          </div>

          <div className="payment-execution-step__row">
            <span className="payment-execution-step__label">
              {__("wallet.deposit.amount")}
            </span>
            <strong className="payment-execution-step__value">
              {amount} USD
            </strong>
          </div>

          <div className="payment-execution-step__row">
            <span className="payment-execution-step__label">
              {__("wallet.deposit.network")}
            </span>
            <strong className="payment-execution-step__value">{network}</strong>
          </div>

          <div className="payment-execution-step__row">
            <span className="payment-execution-step__label">
              {__("wallet.deposit.status")}
            </span>

            <span className="payment-execution-step__status payment-execution-step__status--success">
              {__("wallet.deposit.success")}
            </span>
          </div>

          <div className="payment-execution-step__row">
            <span className="payment-execution-step__label">
              {__("wallet.deposit.date_time")}
            </span>
            <strong className="payment-execution-step__value">
              {formatTransactionDate(dateTime)}
            </strong>
          </div>
        </div>
      </div>

      <div className="payment-execution-step__actions">
        <button
          type="button"
          className="payment-execution-step__button payment-execution-step__button--secondary"
          onClick={onGoToWallet}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 13.1668C9.87202 13.1668 9.744 13.1182 9.64666 13.0202L4.98 8.35353C4.78466 8.1582 4.78466 7.84151 4.98 7.64617L9.64666 2.97951C9.842 2.78417 10.1587 2.78417 10.354 2.97951C10.5494 3.17484 10.5494 3.49153 10.354 3.68686L6.04071 8.00018L10.354 12.3135C10.5494 12.5088 10.5494 12.8255 10.354 13.0208C10.256 13.1182 10.128 13.1668 10 13.1668Z"
              fill="#FCFCFD"
            />
          </svg>
          {__("wallet.deposit.go_to_wallet")}
        </button>

        <button
          type="button"
          className="payment-execution-step__button payment-execution-step__button--primary"
          onClick={onGoToTrading}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.625 5.2475V5C15.625 2.985 14.515 1.875 12.5 1.875H4.16667C2.9025 1.875 1.875 2.9025 1.875 4.16667V15C1.875 17.015 2.985 18.125 5 18.125H15C17.015 18.125 18.125 17.015 18.125 15V8.33333C18.125 6.5375 17.2433 5.46083 15.625 5.2475ZM16.875 13.125H13.75C12.9458 13.125 12.2917 12.4708 12.2917 11.6667C12.2917 10.8625 12.9458 10.2083 13.75 10.2083H16.875V13.125ZM4.16667 3.125H12.5C13.8142 3.125 14.375 3.68583 14.375 5V5.20833H4.16667C3.5925 5.20833 3.125 4.74083 3.125 4.16667C3.125 3.5925 3.5925 3.125 4.16667 3.125ZM15 16.875H5C3.68583 16.875 3.125 16.3142 3.125 15V6.20748C3.4375 6.36748 3.79167 6.45833 4.16667 6.45833H15C16.3142 6.45833 16.875 7.01917 16.875 8.33333V8.95833H13.75C12.2567 8.95833 11.0417 10.1733 11.0417 11.6667C11.0417 13.16 12.2567 14.375 13.75 14.375H16.875V15C16.875 16.3142 16.3142 16.875 15 16.875ZM14.175 10.8333H14.1833C14.6442 10.8333 15.0167 11.2067 15.0167 11.6667C15.0167 12.1267 14.6442 12.5 14.1833 12.5C13.7233 12.5 13.3458 12.1267 13.3458 11.6667C13.3458 11.2067 13.715 10.8333 14.175 10.8333Z"
              fill="white"
            />
          </svg>
          {__("wallet.deposit.go_to_trading")}
        </button>
      </div>
    </div>
  );
};

export default PaymentExecutionStep;
